import React from 'react';
import { Award, ShieldCheck, TrendingUp, Headset } from 'lucide-react';
import { whyChooseUsData } from '../data/mock';

const iconMap = {
  Award: Award,
  ShieldCheck: ShieldCheck,
  TrendingUp: TrendingUp,
  Headset: Headset
};

export const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A1F3D] mb-4">
            Why Choose <span className="text-[#C9A14A]">Saketh Real Estate</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Your trusted partner in real estate excellence
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyChooseUsData.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={index}
                className="group text-center p-8 rounded-2xl bg-gradient-to-br from-gray-50 to-white hover:from-[#C9A14A]/5 hover:to-[#C9A14A]/10 transition-all duration-500 hover:shadow-xl hover:transform hover:scale-105"
              >
                {/* Icon */}
                <div className="flex justify-center mb-6">
                  <div className="w-20 h-20 bg-[#0A1F3D] rounded-2xl flex items-center justify-center group-hover:bg-[#C9A14A] transition-all duration-300 group-hover:rotate-12">
                    <IconComponent className="w-10 h-10 text-[#C9A14A] group-hover:text-[#0A1F3D] transition-colors duration-300" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-[#0A1F3D] mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-600">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
